/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JobGroup } from './JobGroup';
import {
    JobGroupFromJSON,
    JobGroupFromJSONTyped,
    JobGroupToJSON,
    JobGroupToJSONTyped,
} from './JobGroup';
import type { JobType } from './JobType';
import {
    JobTypeFromJSON,
    JobTypeFromJSONTyped,
    JobTypeToJSON,
    JobTypeToJSONTyped,
} from './JobType';

/**
 * 
 * @export
 * @interface CreateJobRequest
 */
export interface CreateJobRequest {
    /**
     * 
     * @type {JobType}
     * @memberof CreateJobRequest
     */
    jobType: JobType;
    /**
     * 
     * @type {string}
     * @memberof CreateJobRequest
     */
    jobKey: string;
    /**
     * 
     * @type {JobGroup}
     * @memberof CreateJobRequest
     */
    jobGroup: JobGroup;
    /**
     * 
     * @type {string}
     * @memberof CreateJobRequest
     */
    cronExpression: string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobRequest
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateJobRequest
     */
    isEnabled: boolean;
}



/**
 * Check if a given object implements the CreateJobRequest interface.
 */
export function instanceOfCreateJobRequest(value: object): value is CreateJobRequest {
    if (!('jobType' in value) || value['jobType'] === undefined) return false;
    if (!('jobKey' in value) || value['jobKey'] === undefined) return false;
    if (!('jobGroup' in value) || value['jobGroup'] === undefined) return false;
    if (!('cronExpression' in value) || value['cronExpression'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('isEnabled' in value) || value['isEnabled'] === undefined) return false;
    return true;
}

export function CreateJobRequestFromJSON(json: any): CreateJobRequest {
    return CreateJobRequestFromJSONTyped(json, false);
}

export function CreateJobRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateJobRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'jobType': JobTypeFromJSON(json['jobType']),
        'jobKey': json['jobKey'],
        'jobGroup': JobGroupFromJSON(json['jobGroup']),
        'cronExpression': json['cronExpression'],
        'description': json['description'],
        'isEnabled': json['isEnabled'],
    };
}

export function CreateJobRequestToJSON(json: any): CreateJobRequest {
    return CreateJobRequestToJSONTyped(json, false);
}

export function CreateJobRequestToJSONTyped(value?: CreateJobRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'jobType': JobTypeToJSON(value['jobType']),
        'jobKey': value['jobKey'],
        'jobGroup': JobGroupToJSON(value['jobGroup']),
        'cronExpression': value['cronExpression'],
        'description': value['description'],
        'isEnabled': value['isEnabled'],
    };
}

